/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

import type { VNode } from "preact";
import {
  useTemplates,
  useTemplateDetails,
  useMerchantConfig,
  usePayoutAccounts,
} from "../api/hooks.js";
import { CreateTemplateScreen } from "../screens/CreateTemplateScreen.js";

export function CreateTemplateRoute({ editId }: { editId?: string }): VNode {
  const { createTemplate, updateTemplate } = useTemplates();
  const { template, resource: templateResource } = useTemplateDetails(editId);
  const { primaryCurrency, currencies, resource: configResource } = useMerchantConfig();
  const { accounts } = usePayoutAccounts();

  const payoutCurrencies = (accounts ?? [])
    .map((a: { currency?: string }) => a.currency)
    .filter((c: string | undefined): c is string => Boolean(c));

  return (
    <CreateTemplateScreen
      editId={editId}
      template={template}
      templateResource={templateResource}
      defaultCurrency={primaryCurrency}
      configuredCurrencies={Object.keys(currencies ?? {})}
      configResource={configResource}
      payoutCurrencies={payoutCurrencies}
      onCreateTemplate={(id, name, contract, extras) =>
        createTemplate(id, name, contract as never, extras as never)
      }
      onUpdateTemplate={(id, name, contract, extras) =>
        updateTemplate(id, name, contract as never, extras as never)
      }
    />
  );
}
